import React, { useEffect, useState } from "react";
import { Table } from "flowbite-react";

function ManageImage() {
  const [allImages, setAllImages] = useState([]);
  useEffect(() => {
    fetch("https://jewellery-mysql-backend.onrender.com/admin/images")
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.data)) {
          setAllImages(data.data);
        } else if (data.message) {
          console.error("No images found:", data.message);
          setAllImages([]); 
        } else {
          console.error("Unexpected response format:", data);
        }
      
      })
      .catch((error) => {
        console.error("Error fetching images:", error);
        setAllImages([]); 
      });
  }, []);

  const handleDelete = (id) => {
    const token = localStorage.getItem("token");

      if (!token) {
        alert("Authentication token not found. Please log in.");
        return; 
      }
    fetch(`https://jewellery-mysql-backend.onrender.com/admin/delete/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then((res) => res.json())
      .then((data) => {
        alert("Image is deleted successfully");
        setAllImages((prevImages) => prevImages.filter((image) => image.id !== id));
      });
  };
  return (
    <div className="px-4 my-12">
      <h2 className="mb-8 text-3xl font-bold">Manage Your Image</h2>
      <Table className="">
        <Table.Head>
          <Table.HeadCell>No.</Table.HeadCell>
          <Table.HeadCell>Category</Table.HeadCell>
          <Table.HeadCell>Image Url</Table.HeadCell>
          <Table.HeadCell>
            <span>Delete</span>
          </Table.HeadCell>
        </Table.Head>
        {allImages.map((image, index) => (
          <Table.Body className="divide-y" key={image.id}>
            <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
              <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                {index + 1}
              </Table.Cell>
              <Table.Cell>{image.category}</Table.Cell>
              <Table.Cell>{image.imageUrl}</Table.Cell>
              <Table.Cell>
                <button
                  onClick={() => handleDelete(image.id)}
                  className="font-medium text-red-600 hover:underline dark:text-red-500"
                >
                  Delete
                </button>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        ))}
      </Table>
    </div>
  );
}

export default ManageImage;
